import { useRef } from "react";


export const useLatch = <T>(value: T | undefined | null): T | undefined | null => {
	const ref = useRef<T | undefined | null>(value);

	return ref.current = value ?? ref.current;
};